export default async function ({ store, redirect, error, route }) {
    // This runs before the page's fetch (getSurvey) loads oracle's year list,
    // and without it defaultYear is only the calendar year -- which, once
    // stamped into ?year=, outranks the newest year for good. A year already
    // in the URL needs no list.
    if (!route.query.year) {
        await store.dispatch('loadYears')
    }
    // eslint-disable-next-line eqeqeq
    if (store.getters.year && route.query.year != store.getters.year) {
        return redirect({
            path: route.path,
            query: { ...route.query, year: store.getters.year }
        })
    }
}
